export const ColorMap = {
  red: {
    color: "#D3302F",
    credit: "Art with Flo",
    darkImage: "/images/transparent_red_procreate.png",
    hue: "rgba(211, 48, 47, 0.1)",
  },
  blue: {
    color: "#29b6f6",
    credit: "Art with Flo",
    darkImage: "/images/transparent_blue_procreate.png",
    hue: "rgba(24, 118, 210, 0.25)",
  },
  green: {
    color: "#04de37",
    credit: "Rishi Draws",
    darkImage: "/images/transparent_green_procreate1.png",
    hue: "rgba(4, 222, 55, 0.1)",
  },
  purple: {
    color: "#7c4dff",
    credit: "Art with Flo",
    darkImage: "/images/transparent_purple_procreate.png",
    hue: "rgba(124, 77, 255, 0.2)",
  },
};
